<template>
  <div class="loader">
    <base-section>
      <div class="loader-img" />
      <transition name="title" mode="out-in">
        <span class="title" :key="title">
          {{ title }}<span class="dots">{{ dots }}</span>
        </span>
      </transition>
    </base-section>
  </div>
</template>

<script>
const TITLE_DURATION = 3;

export default {
  data() {
    return {
      startTime: null,
      rafId: null,
      tick: 0,
    };
  },
  props: {
    type: {
      validator: value => ['preview', 'publish', 'load'].indexOf(value) !== -1,
    },
  },
  computed: {
    dots() {
      return '.'.repeat(this.tick % 4);
    },
    titles() {
      return this.$t(`loading.${this.type}`);
    },
    title() {
      const tickIndex = parseInt(this.tick / TITLE_DURATION, 10);
      const realIndex = Math.min(tickIndex, this.titles.length - 1);
      return this.titles[realIndex];
    },
    totalTime() {
      return TITLE_DURATION * this.titles.length;
    },
  },
  methods: {
    ticker(time) {
      const duration = Math.max(time - this.startTime, 0);
      this.tick = parseInt(duration / 1000, 10);
      this.rafId = requestAnimationFrame(this.ticker);
    },
  },
  mounted() {
    this.startTime = performance.now();
    this.ticker(this.startTime);
    document.body.classList.add('site-loader');
  },
  destroyed() {
    cancelAnimationFrame(this.rafId);
    document.body.classList.remove('site-loader');
  },
};
</script>

<style scoped src="./baseSiteLoader.css"></style>
